// ============================================================
// CONTACT FORM SUBMISSION ENDPOINT — SINGLE SOURCE OF TRUTH
// ------------------------------------------------------------
// The intake form is configured for FORMSPREE and submits using
// Formspree's JSON API (fetch + Accept: application/json).
//
// PRODUCTION: the endpoint MUST come from the REACT_APP_FORM_ENDPOINT
// environment variable (set it on Render):
//     Static Site → Environment → add
//     REACT_APP_FORM_ENDPOINT = https://formspree.io/f/xxxxxxxx
//
// A Formspree form URL/ID is designed to be PUBLIC and is safe to ship
// in the frontend bundle. DO NOT place any private keys or secrets here.
//
// The form ID/endpoint is intentionally NOT hardcoded in any component.
// ============================================================

// DEV/TESTING FALLBACK ONLY — never relied upon in production.
// Lets the form be exercised locally when REACT_APP_FORM_ENDPOINT is unset.
// Production always uses REACT_APP_FORM_ENDPOINT.
const DEV_TESTING_FALLBACK_ENDPOINT = "https://httpbin.org/post";

export const FORM_ENDPOINT =
  process.env.REACT_APP_FORM_ENDPOINT ||
  (process.env.NODE_ENV !== "production" ? DEV_TESTING_FALLBACK_ENDPOINT : "");

export const isFormConfigured = () => Boolean(FORM_ENDPOINT);
